import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BRAND_FONT_ID_PREFIX, setBrandFonts } from '../config';
import {
  getMediaStudioColors,
  getMediaStudioFonts,
  getMediaStudioImages,
  loadMediaStudioFontFile,
} from '../../redux/settings/media-studio/mediaStudioSettingsActions';

const useBrandAssets = ({ features }) => {
  const dispatch = useDispatch();
  const fonts = useSelector((state) => state.mediaStudioSettings.fonts);
  const fontFamilies = useSelector((state) => state.mediaStudioSettings.fontFamilies);

  useEffect(() => () => setBrandFonts([]), []);

  useEffect(() => {
    if (features.brandImages) {
      dispatch(getMediaStudioImages());
    }
  }, [dispatch, features.brandImages]);

  useEffect(() => {
    if (features.brandFonts) {
      dispatch(getMediaStudioFonts());
    }
  }, [dispatch, features.brandFonts]);

  useEffect(() => {
    if (features.brandColors) {
      dispatch(getMediaStudioColors());
    }
  }, [dispatch, features.brandColors]);

  useEffect(() => {
    if (features.brandFonts) {
      fonts.forEach((font) => dispatch(loadMediaStudioFontFile(font.id)));
    }
  }, [dispatch, features.brandFonts, fonts]);

  useEffect(() => {
    setBrandFonts(
      features.brandFonts
        ? fonts
            .filter((font) => fontFamilies[font.id])
            .map((font) => ({
              id: `${BRAND_FONT_ID_PREFIX}${font.id}`,
              label: font.label,
              stack: `"${fontFamilies[font.id]}", sans-serif`,
            }))
        : [],
    );
  }, [features.brandFonts, fonts, fontFamilies]);
};

export default useBrandAssets;
